import { render, staticRenderFns } from "./InvoicePositionsSum.vue?vue&type=template&id=05b68b88&scoped=true"
import script from "./InvoicePositionsSum.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvoicePositionsSum.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./InvoicePositionsSum.vue?vue&type=style&index=0&id=05b68b88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b68b88",
  null
  
)

export default component.exports